export interface Category {
  slug: string;
  name: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: "zhibo-zixun",
    name: "直播资讯",
    description: "直播行业最新动态、趋势分析和深度报道，帮你把握行业脉搏",
  },
  {
    slug: "lanmu-tuijian",
    name: "栏目推荐",
    description: "精选优质直播栏目，涵盖音乐、美食、旅行、科技等多个领域",
  },
  {
    slug: "shiyong-jiaocheng",
    name: "使用教程",
    description: "从入门到精通的直播教程，设备选购、技巧分享、数据分析一应俱全",
  },
  {
    slug: "pingtai-dongtai",
    name: "平台动态",
    description: "糖果直播平台最新功能发布、活动回顾和官方公告",
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};